import * as Yup from "yup";
import "./join-us.css";
import { handleError, handleSuccess } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import http from "../../core/service/http";



export const useThirdViewHook = ({ handleNext, formData }) => {
    const [showPassword, setShowPassword] = useState(false);
   
    const navigate = useNavigate();
    const [isTermsAccepts, setTermsAccepted] = useState(false);
    const validationSchema = Yup.object({
      firstName: Yup.string()
      .max(12, 'First name must be at most 12 characters')
       .required('First name is required'),
       lastName: Yup.string()
       .max(12, 'Last name must be at most 12 characters')
       .required('Last name is required'),
       password: Yup.string()
       .min(6, 'Password must be at least 6 characters')
       .max(12, 'Password must be at most 12 characters')
       .required('Password is required'),
     email: Yup.string()
       .email('Invalid email address')
       .required('Email is required'),
     phone: Yup.string()
     .required('Phone number is required')
   });
   
   const togglePasswordVisibility = () => {
     setShowPassword(!showPassword);
   };
 
   const handleNavigate = () => {
     navigate("/");
   }
 
   const handleSubmit = async ({ setSubmitting, setErrors }) => {
     setSubmitting(true);
     try {
       const response = await http.post("/v1/auth/register", {
         firstName: formData.firstName,
         lastName: formData.lastName,
         email: formData.email,
         password: formData.password,
         address: formData.address,
         contactNo: formData.phone,
         country: formData.country,
         city: formData.city,
         zipCode: formData.zip,
         sponsorId: formData.member_id,
         token: formData.token,
       });
 
       if (response) {
         handleSuccess("Email has been sent");
         setTimeout(() => {
           navigate("/");
         }, 2000)
       }
 
     } catch (error) {
       console.error("Login failed", error);
       if (error.response) {
         handleError({ email: error.response.data.message || "Login failed" });
       } else {
         handleError({ email: "Network error. Please try again later." });
       }
     }
     setSubmitting(false);
   };
 
    
    return{
        showPassword,
        isTermsAccepts,
        formData,
        setTermsAccepted,
        validationSchema,
        togglePasswordVisibility,
        handleNavigate,
        handleSubmit,
    };
}